import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
export default store => {
  return {
    path: "class",
    component: withAsyncRouteLoading(() => {
      return Promise.all([
        import(/* webpackChunkName: "class" */ "./components"),
        import(/* webpackChunkName: "class" */ "./modules/Module"),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: importedModule1.NAME,
          reducer,
        });
        return component;
      });
      //.catch(err => {
      // throw err;
      // });
    }),
  };
};
